<template>
  <q-field
      borderless
      v-model="fieldValue"
      :rules="field.required ? [ val => val && val === true || requiredText] : []"
  >
  <q-toggle v-model="fieldValue"
             debounce="1000"
            :keep-color="true"
            color="primary"
            checked-icon="s_check"
  />
    <div class="q-field__native row inline no-wrap items-center mw-form-v2-toggle-label-padding">{{ field.label }}</div>
  </q-field>
</template>

<script>
import {mapFields} from "vuex-map-fields";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {

    };
  },
  emits: ['update:modelValue'],
  methods: {

  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return !!this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
